import React, { Suspense, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Notifier from '@knowins/notifier';

import theme from './theme';
import router from './router';

import { LoadingFullpage } from 'features/Loading';
import { initializeExtDirectBatching } from 'api/extDirectBatching';
// import { Alert } from '@knowins/notifier';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});

// Global auth ready state
export const authReady = { current: false };

const App: React.FC = () => {
  const [isAuthReady, setIsAuthReady] = useState(false);

  useEffect(() => {
    // Initialize request batching to overcome HTTP/1.1 connection limits
    initializeExtDirectBatching();

    // Check if user is already authenticated
    const token = localStorage.getItem('jwt_token');
    const login = localStorage.getItem('login');
    if (token && login === 'true') {
      authReady.current = true;
      setIsAuthReady(true);
    } else {
      authReady.current = false;
      setIsAuthReady(true); // Allow app to load even if not authenticated
    }
  }, []);

  if (!isAuthReady) {
    return <LoadingFullpage />;
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Suspense fallback={<LoadingFullpage />}>
            <QueryClientProvider client={queryClient}>
              <Notifier withThemeProvider={false} />
              {/* <SnackbarProvider
                maxSnack={3}
                anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                preventDuplicate
                Components={{
                  info: Alert,
                  error: Alert,
                  success: Alert,
                  warning: Alert,
                  default: Alert,
                }}
              /> */}
              <RouterProvider router={router}></RouterProvider>
            </QueryClientProvider>
          </Suspense>
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
